import { atom } from 'recoil';

export const LinkState = atom({
    key: 'LinkState',
    default: null
});